import GeneralSettings from './general-settings'

export default GeneralSettings
